<template>
  <div class="flex items-center w-screen h-screen z-0 absolute overflow-hidden">
    <img alt="background-image"
         class="bg absolute inset-0 object-cover h-full w-full" src="/images/bg/bearbeitet_weniger_rost_0.jpg"/>
    <div class="bg-overlay absolute inset-0 bg-gradient-to-b from-surface-900/40 to-surface-900/5"></div>
  </div>

  <div class="flex items-center content-center z-10 min-h-screen relative justify-center overflow-y-scroll">
    <Container class="h-screen">
      <h1 class="font-bold text-left text-6xl text-white my-6">
        {{ $t("pages.r156_information.r156_information") }}
      </h1>

      <div class="flex column items-center content-center justify-center">
        <Card class="max-w-xl w-full">
          <template #content>
            <div class="flex flex-col gap-8 mb-4">
              <section>
                <h5 class="text-xl font-bold text-surface-700 mb-1">{{ $t('pages.r156_information.diag_plus_plus_subtitle') }}</h5>
                <p class="text-surface-700 leading-relaxed">{{ $t('pages.r156_information.diag_plus_plus_message') }}</p>
              </section>

              <section>
                <h5 class="text-xl font-bold text-surface-700 mb-1">{{ $t('pages.r156_information.diag_plus_plus_subtitle2') }}</h5>
                <p class="text-surface-700 leading-relaxed">{{ $t('pages.r156_information.diag_plus_plus_message_2') }}</p>
              </section>

              <section>
                <h5 class="text-xl font-bold text-surface-700 mb-1">{{ $t('pages.r156_information.diag_plus_plus_subtitle3') }}</h5>
                <p class="text-surface-700 leading-relaxed">{{ $t('pages.r156_information.diag_plus_plus_message_3') }}</p>
              </section>

              <section>
                <h5 class="text-xl font-bold text-surface-700 mb-1">{{ $t('pages.r156_information.diag_plus_plus_subtitle4') }}</h5>
                <p class="text-surface-700 leading-relaxed">{{ $t('pages.r156_information.diag_plus_plus_message_4') }}</p>
              </section>
            </div>
          </template>
        </Card>
      </div>
    </Container>
  </div>
</template>

<script>

import Container from "@/Components/Container.vue";

export default {
  name: "R156InformationView",
  components: {
    Container,
  },
}
</script>